import React, { FC, useState } from "react";
import {
  Badge,
  IconButton,
  Menu,
  List,
  ListItem,
  ListItemText,
  Box,
  LinearProgress,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { Check, Close, Loop } from "@mui/icons-material";

import { JobStatus, JobStep } from "types";

interface Props {
  notifications: JobStatus[];
}

const Notifications: FC<Props> = ({ notifications }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const isDone = (jobStatus: JobStatus): boolean => {
    return jobStatus.step === JobStep.Done;
  };

  const getPercentage = (jobStatus: JobStatus): number => {
    if (jobStatus.step === JobStep.Done && !jobStatus.hasError) {
      return 100;
    }
    const fetchJobsCount = jobStatus.fetchJobs.length;
    if (jobStatus.step === JobStep.Transformation) {
      const fetchPercentageDone = (fetchJobsCount/(fetchJobsCount+1)) * 100;
      return (jobStatus.transformationPercentage/(fetchJobsCount+1)) + fetchPercentageDone;
    }

    const fetchpercentage = jobStatus.fetchJobs.reduce(
      (acc, job) => acc + job.percentage,
      0
    );
    return fetchpercentage / (fetchJobsCount+1);
  };

  return (
    <>
      <IconButton color="inherit" onClick={handleClick}>
        <Badge badgeContent={notifications.length} color="secondary">
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <List sx={{ minWidth: "5em" }}>
          {notifications.length > 0 ? (
            notifications.map((notification, index) => (
              <ListItem key={index} sx={{ minWidth: "20em" }}>
                {isDone(notification) ? (
                  <Check />
                ) : notification.hasError === true ? (
                  <Close />
                ) : (
                  <Loop />
                )}
                <Box sx={{ width: "100%", padding: "0em 1em" }}>
                  <ListItemText
                    primary={`${notification.clientName} (${notification.fetchJobs.length} jobs): ${notification.isFullSync ? "Full Sync" : "Delta Sync"}`}
                    secondary={notification.statusMessage}
                  />
                  <LinearProgress
                    variant="determinate"
                    value={getPercentage(notification)}
                    color={notification.hasError ? "error" : "success"}
                  />
                </Box>
              </ListItem>
            ))
          ) : (
            <ListItem sx={{ minWidth: "20em" }}>
              <ListItemText primary="No running jobs" />
            </ListItem>
          )}
        </List>
      </Menu>
    </>
  );
};

export default Notifications;
